import React from 'react';
import { AccountInfo } from 'structure/Layouts/LayoutWithSideBar/AccountInfo';
import { ConnectButton } from 'components/ConnectButton';
import { ButtonIcon } from '@dapp/multi-lib/sdaoui/ButtonIcon';
import { Icon } from '@dapp/multi-lib/sdaoui/Icon';
import Image from 'next/image';
import { useConnection } from 'wagmi';
import { useClientRenderDelay } from 'utils/hooks/useClientRenderDelay';
import { getStaticAssetUrl } from 'utils/url';

interface HeaderCommonMobileProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const HeaderCommonMobile = (props: HeaderCommonMobileProps) => {
  const { open, onOpenChange } = props;

  const account = useConnection();
  const csr = useClientRenderDelay();
  return (
    <div className='relative mt-1.5 h-[57px] w-full'>
      <div className='absolute left-0 top-0 flex h-[57px] w-full items-center justify-center'>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='369'
          height='57'
          viewBox='0 0 369 57'
          fill='none'
        >
          <path
            d='M0 24.0642V20C0 8.9543 8.9543 0 20 0H349C360.046 0 369 8.9543 369 20V24.0642C369 35.1099 360.046 44.0642 349 44.0642H280.909C275.695 44.0642 270.687 46.1006 266.952 49.7394L265.325 51.3248C261.59 54.9636 256.582 57 251.368 57H124.433C119.638 57 115.002 55.2773 111.371 52.1458L107.629 48.9184C103.998 45.7869 99.3622 44.0642 94.5672 44.0642H20C8.95431 44.0642 0 35.1099 0 24.0642Z'
            fill='#141414'
          />
        </svg>
      </div>
      <div className='relative flex h-[44px] w-full flex-row items-center rounded-[20px] bg-[#141414] pl-4 pr-2'>
        <div className='basis-1/3'>
          <Image
            className='h-[28px]'
            alt='Singularity Finance'
            src={getStaticAssetUrl(
              '/sfi/static/logo/singularity_finance_full_logo.svg'
            )}
            width={83}
            height={28}
          />
        </div>

        <div className='relative top-[10px] flex basis-1/3 justify-center'>
          {account.isConnected && csr ? (
            <AccountInfo button={{ className: 'bg-[#000000]' }} />
          ) : (
            <ConnectButton className='text-nowrap' />
          )}
        </div>

        <div className='basis-1/3'>
          <ButtonIcon className='ml-auto' onClick={() => onOpenChange(!open)}>
            {open ? (
              <Icon icon='close' color='#B4BCD0' />
            ) : (
              <Icon icon='menu' color='#B4BCD0' />
            )}
          </ButtonIcon>
        </div>
      </div>
    </div>
  );
};
